import { ThemeEvents } from '@theme/events';

/* ===============================
   CART PROGRESS BAR
================================ */

const FREE_SHIPPING = 2500;
const MAX_LIMIT = 10000;

function updateProgressBar(cart) {
  const textEl = document.querySelector('.cart-progress-text');
  const fillEl = document.querySelector('.cart-progress-fill');

  if (!textEl || !fillEl || !cart) return;

  const cartTotal = cart.total_price / 100;

  if (cartTotal >= FREE_SHIPPING) {
    textEl.textContent = "🎉 You’ve unlocked FREE SHIPPING!";
  } else {
    const remaining = FREE_SHIPPING - cartTotal;
    textEl.textContent = `Shop more for ₹${remaining} to get FREE SHIPPING`;
  }

  const percentage = Math.min((cartTotal / MAX_LIMIT) * 100, 100);
  fillEl.style.width = `${percentage}%`;
}

/* Listen to cart updates (quantity, remove, discount, add) */
document.addEventListener(ThemeEvents.cartUpdate, (event) => {
  updateProgressBar(event.detail.data);
});

/* Initial load */
fetch('/cart.js')
  .then(res => res.json())
  .then(cart => updateProgressBar(cart));
